import script from "./ShopGoodItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShopGoodItem.vue?vue&type=script&lang=ts&setup=true"

import "./ShopGoodItem.vue?vue&type=style&index=0&id=519b6310&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-519b6310"]])

export default __exports__